module.exports = __webpack_public_path__ + "prod/1.42.2/img/esign-logo.572b4776.svg";